import { z } from "zod";
import { API_ERROR } from "../apiErrors";

/**
 * Tělo změny vazeb zájezd ↔ inspirace (vize C5 / F6.1) — jediné schéma obou podzdrojů
 * `PATCH /api/admin/trips/:id/inspirations` a `PATCH /api/admin/inspirations/:id/trips`.
 *
 * Změna je ROZDÍL, ne celý nový seznam: `add` přidá chybějící dvojice, `remove` odebere
 * existující, opakované volání nic nezmění. Proto dvě nezávislé strany (editor zájezdu
 * a editor inspirace) nepřepíšou jedna druhé vazby, které právě neviděly, a import (F6.4)
 * posílá jen `add`.
 *
 * Strop {@link TRIP_ACTIVITY_LINKS_MAX_PER_ARRAY} ID na pole omezuje velikost jedné změny
 * (import posílá nejvýš jeden `PATCH` na inspiraci). Limit D1 na 100 vázaných parametrů
 * v jednom dotazu tím vyřešený NENÍ: dotaz může nést i jiné parametry a seznam navázaných
 * bývá delší než jedna změna, proto podzdroj čte a ověřuje přes `fetchChunked`.
 *
 * ID v `add` i `remove` zároveň je chyba celé změny (horní chyba, `path: []`) s kódem
 * `trip_link_overlap` — pořadí „nejdřív přidej, pak odeber" by bylo tiché rozhodnutí.
 */
export const TRIP_ACTIVITY_LINKS_MAX_PER_ARRAY = 100;

const linkIds = z.array(z.string().min(1)).max(TRIP_ACTIVITY_LINKS_MAX_PER_ARRAY).default([]);

export const tripActivityLinksPatchSchema = z
  .object({ add: linkIds, remove: linkIds })
  .superRefine((data, ctx) => {
    const removed = new Set(data.remove);
    if (data.add.some((id) => removed.has(id))) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: API_ERROR.trip_link_overlap });
    }
  });

export type TripActivityLinksPatch = z.infer<typeof tripActivityLinksPatchSchema>;
